import {useQuery} from "@tanstack/react-query";
import {APILandingRequest, APICardRequest} from "../API/api";


export const useAdCategories = () => useQuery({
    queryKey: ['categories'],
    queryFn: APILandingRequest.getCategories,
    staleTime: 3_600_000
})

export const useRecentAds = () => useQuery({
    queryKey: ['recentAds'],
    queryFn: () => APICardRequest.getAllAds({page: 1, page_size: 12}),
    staleTime: 60_000,
    select: (res) => res?.data || []
})